// extracted by mini-css-extract-plugin
export var box = "_4l-1";
export var checkboxRow = "_4l-8";
export var checked = "_4l-2";
export var descriptionSpacer = "_4l-a";
export var disabled = "_4l-3";
export var icon = "_4l-6";
export var input = "_4l-0";
export var labelSpacer = "_4l-9";
export var medium = "_4l-5";
export var small = "_4l-4";
export var text = "_4l-7";